import { Component, EventEmitter, Input, Output } from '@angular/core'
import {
	CheckboxControlValueAccessor,
	FormGroup,
	FormsModule,
	NG_VALUE_ACCESSOR,
	ReactiveFormsModule,
} from '@angular/forms'
import { MatCheckbox, MatCheckboxChange } from '@angular/material/checkbox'
import { NgStyle } from '@angular/common'
import { MatError } from '@angular/material/input'

@Component({
	selector: 'form-checkbox',
	templateUrl: './Checkbox.Component.html',
	providers: [
		{
			provide: NG_VALUE_ACCESSOR,
			useExisting: CheckboxComponent,
			multi: true,
		},
	],
	imports: [MatCheckbox, FormsModule, ReactiveFormsModule, NgStyle, MatError],
})
export class CheckboxComponent extends CheckboxControlValueAccessor {
	@Input() public checked: boolean

	@Input() public readonly form: FormGroup

	@Input() public readonly id: string

	@Input() public readonly error: string

	@Input() public readonly formControlName: string

	@Input() public readonly prefix: string

	@Input() public readonly label: string

	@Input() public readonly suffix: string

	@Input() public readonly disabled: boolean

	@Input() public readonly styles: { [style: string]: string | number }

	@Output() private readonly checkedChange = new EventEmitter<boolean>()

	public onTouched: () => void

	public onChange: (value: boolean) => void

	public registerOnChange(fn: (value: boolean) => void): void {
		this.onChange = fn
	}

	public registerOnTouched(fn: () => void): void {
		this.onTouched = fn
	}

	public handleChange = (change: MatCheckboxChange): void => {
		this.checked = change.checked
		this.checkedChange.emit(this.checked)
	}
}
